import { Box } from '@mui/material';
import React, { useLayoutEffect, useRef } from 'react';
import BaseVideo from 'components/video/BaseVideo';
import { useMediaQuery } from '@mui/system';
import appTheme from 'ui-blocks/AppTheme';
import { ASSETS } from 'constants/Constants';
import { heroSectionStyles } from '../heroSectionStyles';

export default function HeroSectionVideos() {
	const isMobile = useMediaQuery(appTheme.breakpoints.down('mobileUi'));
	const containerRef = useRef(null);

	const videoRefs = ASSETS.heroSectionVideos.map(() => useRef(null));
	const centerIndex = Math.floor(ASSETS.heroSectionVideos.length / 2);

	useLayoutEffect(() => {
		if (containerRef.current) {
			const container = containerRef.current;
			container.scrollLeft = (container.scrollWidth - container.clientWidth) / 2;
		}
	}, []);

	const handleMouseEnter = (index) => {
		if (index !== centerIndex) {
			videoRefs[centerIndex]?.current?.handleVideoPause();
		}
		videoRefs[index]?.current?.handleVideoPlay();
	};

	const handleMouseLeave = (index) => {
		if (index !== centerIndex) {
			videoRefs[index]?.current?.handleVideoPause();
		}
		videoRefs[centerIndex]?.current?.handleVideoPlay();
	};

	return (
		<Box
			id="hero-section-video-container"
			sx={[heroSectionStyles.heroSectionVideosContainer]}
			ref={containerRef}
		>
			{ASSETS.heroSectionVideos.map((video, index) => (
				<Box
					key={`hero-video-${video.id}`}
					onMouseEnter={() => handleMouseEnter(index)}
					onMouseLeave={() => handleMouseLeave(index)}
					sx={{ flexShrink: 0 }}
				>
					<BaseVideo
						ref={videoRefs[index]}
						id={`hero-video-${index}`}
						src={video.src}
						poster={video.thumbnail}
						controls={false}
						autoPlay={isMobile || index === centerIndex}
						muted
						loop
						playPauseIcon={false}
						showSkeletonLoading
						playsInline
						style={heroSectionStyles.videoStyles}
						containerStyle={heroSectionStyles.baseVideoContainerStyles}
					/>
				</Box>
			))}
		</Box>
	);
}
